import { useStyles } from '@archipro-design/aria';
import { Flex, Button, useAppDisplayModeContext } from '@archipro-design/aria';
import { CloseCircleLine } from '@archipro-design/icons';
import type { AppliedFilterItem } from '../../type/filter-state';
import * as S from './AppliedFilters.style';

interface AppliedFiltersProps {
    filterItems: AppliedFilterItem[];
    resetFilters: () => void;
}

const AppliedFilters = ({ filterItems, resetFilters }: AppliedFiltersProps) => {
    const { css } = useStyles();
    const { mobile } = useAppDisplayModeContext();
    return (
        <Flex wrap className={css(S.AppliedFiltersContainer)}>
            {filterItems.map((item, index) => (
                <Button
                    key={index}
                    transparent
                    size={mobile ? 14 : 18}
                    variables={{ buttonPadding: 0, iconPadding: 0 }}
                    iconBefore={<CloseCircleLine />}
                    onClick={() => item.action()}
                >
                    {item.label}
                </Button>
            ))}
            <Button
                key="AppliedFilters-clearAll"
                transparent
                size={mobile ? 14 : 18}
                variables={{ buttonPadding: 0, iconPadding: 0 }}
                selected
                onClick={() => resetFilters()}
            >
                Clear all
            </Button>
        </Flex>
    );
};

export default AppliedFilters;
